import { createReducer } from '@reduxjs/toolkit';
import { getLoanTypeAction, setLoanTypeAction } from 'app/redux/actions/LoanTypeAction';
import { ICommonState } from 'app/interfaces/reducer-interface/common.interface';
import { IOptions } from 'app/interfaces/input/input.interface';

export interface ILoanTypeState extends ICommonState {
    loanTypeList: IOptions[];
}

const initialState: ILoanTypeState = {
	loading: false,
	loanTypeList: [],
	error: '',
	message: '',
};

const loanTypeReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(getLoanTypeAction, (state) => ({
			...state,
			loading: true,
		}))
		.addCase(setLoanTypeAction, (state, action) => ({
			...state,
			loading: true,
            loanTypeList: action.payload.data
                .filter((item) => item.status === "ACTIVE")
                .map((item) => ({
                    label: item.name,
                    value: item.loanTypeId
                })),
			message: action.payload.message,
		}))
		.addDefaultCase((state) => ({ ...state }));
});

export default loanTypeReducer;
